import CryptoJS from "crypto-js";

export default function(text) {
  return CryptoJS.MD5(CryptoJS.enc.Utf8.parse(text)).toString();
}
